import React, { useEffect, useState, useRef } from 'react';
import { Button, Divider, Card, Typography } from 'antd';
import axios from 'axios';
import ApexCharts from 'apexcharts';
import Chart from "react-apexcharts";



const ApexChart = ({ refreshTrigger }) => {

  const [series, setSeries] = useState([
    {
      name: "Weight",
      data: []
    }
  ]);

  const [unit, setUnit] = useState();

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/track-weights/graph`,
          { withCredentials: true }); 
        const { preferredQuantityType, Data } = response.data;

        // Map API data to ApexCharts format
        const chartData = Data.map((entry) => ({
          x: entry.trackdate,
          y: preferredQuantityType === "metric" ? entry.metric : entry.imperial
        }));

        setSeries([{ name: "Weight",  data: chartData }]);
        setUnit(preferredQuantityType === "metric" ? "Kilograms" : "Pounds")
      } catch (error) {
        console.error("Error fetching weight data", error);
      }
    }

    fetchData();
  }, [refreshTrigger]);


const options = {
  chart: {
    type: "line",
    height: 350
  },
  stroke: {
  curve: 'smooth',
   width: 2
},
colors:['#2c7906ff'],
markers: {
    size: 4,
},
title: {
          text: 'Weight Measurements'
        },
  xaxis: {
    type: "datetime",
    labels: {
      datetimeFormatter: {
        day: "dd MMM"
      }
    },
    title: {text: "Date of Measure"}
  },
  yaxis: {
    title: {text: unit}
  },
  tooltip: {
    x: {
      format: "dd MMM"
    },
    y: {formatter: (val) => `${val} ${unit}`}
  }
};

 return (
    <div>
      <Chart options={options} series={series} type="line" height={350} />
    </div>
  );

}

export default ApexChart;